var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14","viewBox":"0 0 14 14"}},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"fill":"#FFF","stroke":"#666"}},[_c('g',{attrs:{"transform":"translate(-544 -448) translate(545 449)"}},[_c('circle',{attrs:{"cx":"6","cy":"6","r":"6"}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }